import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const configuratorStep = atom<'hero' | 'color' | 'picker' | 'multipicker' | 'banners' | 'form' | 'group'>({
    key: 'configuratorStep',
    default: 'hero',
});

export const useConfiguratorStepValue = () => useRecoilValue(configuratorStep);

export const useSetConfiguratorStepState = () => {
    return useSetRecoilState(configuratorStep);
};
